import { Classes } from '@blueprintjs/core';
import { TimePrecision } from '@blueprintjs/datetime';
import { DateInput2 as BlueprintDateInput } from '@blueprintjs/datetime2';
import * as React from 'react';

import { parseDatePickerInput } from 'bones/utils/dates/parseDatePickerInput';
import {
  formatDate,
  getXsdDateStringFromDate,
  getXsdDateTimeStringFromDate,
} from 'bones/utils/dates/xsdFormat';

export interface DateInputProps {
  onSetValue: (value: string) => void;
  placeholder?: string;
  testId?: string;
  time?: boolean;
  value: string | null;
}

export const DateInput: React.VFC<DateInputProps> = ({
  onSetValue,
  placeholder,
  testId,
  time,
  value,
}) => {
  return (
    <div className="sd-input-date" data-testid={testId}>
      <div className={Classes.CONTROL_GROUP}>
        <BlueprintDateInput
          formatDate={formatDate}
          maxDate={new Date('01/01/3000')}
          minDate={new Date('01/01/1000')}
          onChange={(nextValue) => {
            if (!nextValue) {
              onSetValue('');
              return;
            }
            let newDate = '';
            if (time) {
              const date = new Date(nextValue);
              newDate = getXsdDateTimeStringFromDate(date);
            } else {
              const date = new Date(`${nextValue}T00:00:00`);
              newDate = getXsdDateStringFromDate(date);
            }
            onSetValue(newDate.split('+')[0]);
          }}
          parseDate={parseDatePickerInput}
          placeholder={placeholder}
          showTimezoneSelect={false}
          timePickerProps={
            time ? { showArrowButtons: true, useAmPm: true } : undefined
          }
          timePrecision={time ? TimePrecision.SECOND : undefined}
          value={value}
        />
      </div>
    </div>
  );
};
